import { render, staticRenderFns } from "./NominationConferenceList.vue?vue&type=template&id=ffa02c48"
import script from "./NominationConferenceList.vue?vue&type=script&lang=js"
export * from "./NominationConferenceList.vue?vue&type=script&lang=js"
import style0 from "./NominationConferenceList.vue?vue&type=style&index=0&id=ffa02c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports